import {Form} from 'vform';
window.Form = Form;
